import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import { ImgixImage } from "~/components/ImgixImage";
import { getCloudFrontUrlFromImgixUrl } from "~/constants/cloudfront";
import { getPreferenceImgixFit, useThumbnailPreference } from "~/hooks/useThumbnailPreference";
import { CentralizedBoardSelectors } from "~/store/centralizedBoard/selectors";
import { BOARD_THUMBNAIL_DIMENSIONS } from "./dimensions";
export const BoardCellThumbnail = /*#__PURE__*/ memo((param)=>{
    let { title, thumbnail } = param;
    const fallbackUrl = thumbnail && getCloudFrontUrlFromImgixUrl(thumbnail);
    const { getPreference } = useThumbnailPreference();
    const boardId = useSelector(CentralizedBoardSelectors.boardId);
    const thumbnailPreference = useMemo(()=>getPreference(boardId), [
        boardId,
        getPreference
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex h-full items-center justify-center rounded-4 border border-solid border-pigeon-100 bg-white p-1",
        children: fallbackUrl ? /*#__PURE__*/ _jsx(ImgixImage, {
            fallbackUrl: fallbackUrl,
            alt: title,
            src: thumbnail,
            imgixParams: {
                auto: "compress",
                fit: getPreferenceImgixFit(thumbnailPreference),
                cs: "origin"
            },
            style: {
                borderRadius: "2px",
                objectFit: thumbnailPreference === "default" ? "cover" : "contain",
                ...BOARD_THUMBNAIL_DIMENSIONS
            },
            ...BOARD_THUMBNAIL_DIMENSIONS
        }) : /*#__PURE__*/ _jsx("div", {
            className: "size-full bg-pigeon-100"
        })
    });
});
BoardCellThumbnail.displayName = "BoardCellThumbnail";
